
import BannerImage from './BannerImage';

export default BannerImage;


